"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _wsProvider = _interopRequireDefault(require("./providers/ws-provider"));

var _httpProvider = _interopRequireDefault(require("./providers/http-provider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class MEWProvider {
  constructor(host, options, store, eventHub) {
    if (host && typeof host === 'string') {
      if (/^http(s)?:\/\//i.test(host)) {
        store.noSubs = true;
        return new _httpProvider.default(host, options, store, eventHub);
      } else if (/^ws(s)?:\/\//i.test(host)) {
        return new _wsProvider.default(host, options, store, eventHub);
      } else if (host) {
        throw new Error('Can\'t autodetect provider for "' + host + '"');
      }
    }
  }

}

var _default = MEWProvider;
exports.default = _default;